document.addEventListener('DOMContentLoaded', function () {
    const headers = document.querySelectorAll('.accordion-header');

    headers.forEach((header) => {
        header.addEventListener('click', function () {
            const content = this.nextElementSibling;

            // Sluit alle andere items
            document.querySelectorAll('.accordion-content').forEach((item) => {
                if (item !== content) {
                    item.style.maxHeight = null;
                    item.classList.remove('open');
                }
            });

            // Open of sluit het huidige item
            if (content.classList.contains('open')) {
                content.style.maxHeight = null;
                content.classList.remove('open');
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
                content.classList.add('open');
            }
        });
    });
});